module.exports = __webpack_public_path__ + "img/stick_activites_paintball.1f3190f3.svg";